import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import AppModal from "../Generic/AppModal/AppModal";

interface Props {
  isOpen: boolean;
  onClickRequest: () => void;
  onClickClose: () => void;
}

export default function RequestVisitModal(props: Props) {
  return (
    <AppModal
      type="info"
      isOpen={props.isOpen}
      title={translate(STRINGS.REQUEST_VISIT)}
      message={translate(STRINGS.ARE_YOU_SURE_YOU_WANT_TO_REQUEST_THIS_VISIT)}
      onRequestClose={props.onClickClose}
      actions={[
        {
          key: "yes",
          variant: "soft",
          color: "primary",
          children: translate(STRINGS.YES),
          onClick: props.onClickRequest,
        },
        {
          key: "no",
          variant: "link",
          color: "black",
          children: translate(STRINGS.I_HAVE_CHANGED_MY_MIND),
          onClick: props.onClickClose,
        },
      ]}
    />
  );
}
